function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M20.949 1C9.931 1 1 9.931 1 20.949c0 11.018 8.931 19.949 19.949 19.949 11.018 0 19.949-8.931 19.949-19.949C40.898 9.931 31.967 1 20.949 1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M22.096 30.833H18.03V21.25H16v-3.303h2.031v-1.982c0-2.694 1.146-4.297 4.405-4.297h2.712v3.303h-1.695c-1.269 0-1.352.462-1.352 1.323l-.006 1.653h3.072l-.36 3.303h-2.712v9.584z"
}));

function SvgFacebookFillWhiteGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MiA0MiI+CiAgICA8ZyBmaWxsPSJub25lIj4KICAgICAgICA8cGF0aCBzdHJva2U9IiNGRkYiIGQ9Ik0xOS45NDkgMEM4LjkzMSAwIDAgOC45MzEgMCAxOS45NDljMCAxMS4wMTggOC45MzEgMTkuOTQ5IDE5Ljk0OSAxOS45NDkgMTEuMDE4IDAgMTkuOTQ5LTguOTMxIDE5Ljk0OS0xOS45NDlDMzkuODk4IDguOTMxIDMwLjk2NyAwIDE5Ljk0OSAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0yMS4wOTYgMjkuODMzSDE3LjAzVjIwLjI1SDE1di0zLjMwM2gyLjAzMXYtMS45ODJjMC0yLjY5NCAxLjE0Ni00LjI5NyA0LjQwNS00LjI5N2gyLjcxMnYzLjMwM2gtMS42OTVjLTEuMjY5IDAtMS4zNTIuNDYyLTEuMzUyIDEuMzIzbC0uMDA2IDEuNjUzaDMuMDcybC0uMzYgMy4zMDNoLTIuNzEydjkuNTg0eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFacebookFillWhiteGray as ReactComponent };